import { Component, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ListComponent } from 'src/app/common/component/list.component';
import { MatPaginator } from '@angular/material/paginator';

@Component({
	selector: 'app-www-description-template-list',
	templateUrl: './www-description-template-list.component.html',
	styleUrls: ['./www-description-template-list.component.scss'],
})
export class WwwDescriptionTemplateListComponent extends ListComponent {
	@ViewChild('dataTable') table: MatTable<any>;
	@ViewChild(MatSort) sort: MatSort;
	dataSource = new MatTableDataSource<any>();
	@ViewChild(MatPaginator) paginator: MatPaginator;
	displayedColumns: string[] = ['id', `productKind`, `kind`, `edit`];

	protected apiType = 'bag';
	protected apiUrl = 'www/description_template';

	protected convertData(data: any) {
		this.bag.get('/product/kind/', (value, error) => {
			data.results.map((template) => {
				template.productKind = value.results.find((item) => item.id === template.productKind);
				switch (template.kind) {
					case 'D':
						template.kind = 'Opis';
						break;
					case 'B':
						template.kind = 'Świadczenia';
						break;
					case 'L':
						template.kind = 'Lokalizacja';
						break;
					default:
						break;
				}
			});
		});

		this.dataSource = new MatTableDataSource<any>(data.results);
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;
		this.dataSource.sortingDataAccessor = (item, property) => {
			switch (property) {
				case 'productKind':
					return item.productKind.name;
				default:
					return item[property];
			}
		};

		return this.dataSource;
	}
}
